<template>
  <div id="add-edit-branch-container" class="vx-col w-full">
    <vx-card class="digitelex-popup-content">
      <form autocomplete="off">
        <vx-card title="Vehicle Details">
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Vehicle No</label>
              <!-- :map-keydown="handleVehicleNo" -->
              <v-select
                taggable
                push-tags
                v-model="vehicleDropDown"
                label="vehicleNo"
                :options="vehiclesList"
                :reduce="(vehicleDropDown) => vehicleDropDown.vehicleTypeId"
                :create-option="
                  (vehicleNo) => ({
                    vehicleId: 0,
                    vehicleUniq: null,
                    vehicleNo: vehicleNo,
                    vehicleTypeId: 0,
                    vehicleOwnerName: null,
                    vehicleOwnerMobileNo: null,
                    vehicleOwnerGst: null,
                    vehicleChassisNo: null,
                    vehicleEmptyWeight: null,
                    vehicleAuthorityType: false,
                    vehicleHasAllIndiaPermit: true,
                    vehicleTypeName: '',
                  })
                "
                @option:created="createNewVehicle"
                @option:selected="selectedOption"
              ></v-select>
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('pvehicleId')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("pvehicleId") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('pvehicleId')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                v-validate="'required|min:2'"
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Owner Name"
                label-placeholder="Owner Name"
                name="vehicleOwnerName"
                v-model="frm.vehicleOwnerName"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('vehicleOwnerName')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("vehicleOwnerName") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('vehicleOwnerName')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                v-validate="'decimal:10'"
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Owner Mobile No"
                label-placeholder="Owner Mobile No"
                name="vehicleOwnerMobileNo"
                v-model="frm.vehicleOwnerMobileNo"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('vehicleOwnerMobileNo')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("vehicleOwnerMobileNo") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('vehicleOwnerMobileNo')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="GST No"
                label-placeholder="GST No"
                name="vehicleOwnerGstNo"
                v-model="frm.vehicleOwnerGstNo"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('vehicleOwnerGstNo')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("vehicleOwnerGstNo") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('vehicleOwnerGstNo')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-2/5 w-full mb-2">
              <vs-input
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Chasis No"
                label-placeholder="Chasis No"
                name="VehicleChassisNo"
                v-model="frm.VehicleChassisNo"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('VehicleChassisNo')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("VehicleChassisNo") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('VehicleChassisNo')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
            <div class="vx-col sm:w-1/5 w-full mb-2">
              <label>Empty Vehicle Weight(kg)</label>
              <vs-input-number
                size="medium"
                class="custom-number-input"
                name="vehicleEmptyWeight"
                v-model="frm.vehicleEmptyWeight"
                :step="15"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('vehicleEmptyWeight')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("vehicleEmptyWeight") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('vehicleEmptyWeight')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
            <div class="vx-col sm:w-1/5 w-full mb-2">
              <label>Has All India Permit</label>
              <vs-switch v-model="frm.vehicleHasAllIndiaPermit">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
            <div class="vx-col sm:w-1/5 w-full mb-2">
              <label>Is Owned Vehicle</label>
              <vs-switch v-model="frm.vehicleAuthorityType">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
          </div>
        </vx-card>
        <vx-card title="Trip Details" class="mt-2">
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Driver Name"
                label-placeholder="Driver Name"
                name="tripDriveName"
                v-model="frm.tripDriveName"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('tripDriveName')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("tripDriveName") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('tripDriveName')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                v-validate="'decimal:2'"
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Driver Mobile No"
                label-placeholder="Driver Mobile No"
                name="tripDriverMobileNo"
                v-model="frm.tripDriverMobileNo"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('tripDriverMobileNo')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("tripDriverMobileNo") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('tripDriverMobileNo')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Driver Licence No "
                label-placeholder="Driver Licence No "
                name="tripDriverdlr"
                v-model="frm.tripDriverdlr"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('tripDriverdlr')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("tripDriverdlr") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('tripDriverdlr')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Engaged Through"
                label-placeholder="Engaged Through"
                name="tripEngagedThrough"
                v-model="frm.tripEngagedThrough"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('tripEngagedThrough')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("tripEngagedThrough") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('tripEngagedThrough')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-select
                autocomplete
                label="From"
                v-validate="'required'"
                data-vv-validate-on="input|keyup|blur|click"
                placeholder="From"
                name="fromBranchId"
                v-model="frm.fromBranchId"
                icon="arrow_downward"
                width="100%"
                @change="fromBranchSelected"
                :disabled="sessionRoleId != 1 && sessionRoleId != 2"
              >
                <vs-select-item
                  :key="index"
                  :value="item.branchId"
                  :text="item.branchName"
                  v-for="(item, index) in branches"
                />
              </vs-select>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-select
                autocomplete
                label="To"
                v-validate="'required'"
                data-vv-validate-on="input|keyup|blur|click"
                placeholder="To"
                label-placeholder="vs-Multiple"
                name="toBranchId"
                v-model="frm.toBranchId"
                icon="arrow_downward"
                width="100%"
              >
                <vs-select-item
                  :key="index"
                  :value="item.branchId"
                  :text="item.branchName"
                  v-for="(item, index) in toBranches"
                />
              </vs-select>
            </div>
          </div>
        </vx-card>
        <vx-card title="Consignment Details" class="mt-2">
          <div class="flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto" @click="showAddConsignments = true"
              >Add Consignment</vs-button
            >
          </div>
          <div class="flex">
            <div class="vx-col w-full">
              <vs-table
                pagination
                max-items="10"
                search
                stripe
                :data="frm.consignmentsList"
              >
                <template slot="thead">
                  <vs-th sort-key="consignmentLrNo">LR.No</vs-th>
                  <vs-th sort-key="consignementFromBranchName">From - To</vs-th>
                  <vs-th sort-key="consignor">Consignor</vs-th>
                  <vs-th sort-key="consignee">Consignee</vs-th>
                  <vs-th sort-key="consignmentPackagesTotalCnt"
                    >No.of Articles</vs-th
                  >
                  <vs-th sort-key="consignmentBookedDate">Booking Date</vs-th>
                  <vs-th sort-key="consignmentBookingPaymentTypeName"
                    >Booking Type</vs-th
                  >
                  <vs-th sort-key="consignmentGrandTotalCharge"
                    >Freight Charges</vs-th
                  >
                  <vs-th>Actions</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].consignmentLrNo">{{
                      data[indextr].consignmentLrNo
                    }}</vs-td>
                    <vs-td :data="data[indextr].consignmentToBranchName"
                      >{{ data[indextr].consignmentFromBranchName }} -
                      {{ data[indextr].consignmentToBranchName }}</vs-td
                    >
                    <vs-td :data="data[indextr].consignor"
                      >{{
                        data[indextr].consignor.consignmentConsignorName
                      }}
                      ({{
                        data[indextr].consignor.consignmentConsignorMobileNo
                      }})</vs-td
                    >
                    <vs-td :data="data[indextr].consignee"
                      >{{
                        data[indextr].consignee.consignmentConsigneeName
                      }}
                      ({{
                        data[indextr].consignee.consignmentConsigneeMobileNo
                      }})</vs-td
                    >
                    <vs-td :data="data[indextr].consignmentPackagesTotalCnt">{{
                      data[indextr].consignmentPackagesTotalCnt
                    }}</vs-td>
                    <vs-td :data="data[indextr].consignmentBookedDate">{{
                      data[indextr].consignmentBookedDate | date(true)
                    }}</vs-td>

                    <vs-td
                      :data="data[indextr].consignmentBookingPaymentTypeName"
                      >{{
                        data[indextr].consignmentBookingPaymentTypeName
                      }}</vs-td
                    >
                    <vs-td :data="data[indextr].consignmentGrandTotalCharge">{{
                      data[indextr].consignmentGrandTotalCharge
                    }}</vs-td>
                    <vs-td>
                      <vs-button
                        v-if="
                          frm.tripFlag == 1 ||
                          frm.tripFlag == 2 ||
                          frm.tripFlag == ''
                        "
                        :data="data[indextr]"
                        type="border"
                        size="small"
                        icon-pack="feather"
                        icon="icon-trash"
                        color="danger"
                        @click="removeConsignment(data[indextr], indextr)"
                      ></vs-button>
                      <span v-if="frm.tripFlag == 3">--</span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
          <vs-popup
            class="holamundo digitelex-popup digitelex-higherpopup"
            :title="modalTitle"
            :active.sync="showAddConsignments"
          >
            <!-- Getting the active and the transhipment consignments -->
            <activeLrList
              v-if="showAddConsignments"
              :fromBranchId="localData.branchId"
              :currentBranchId="localData.branchId"
              :selectedConsignmentsListInput="frm.consignmentsList"
              @selectedConsignments="selectedConsignments"
            ></activeLrList>
          </vs-popup>
        </vx-card>
        <vx-card title="Payment Details" class="mt-2">
          <div class="vx-row">
            <div class="vx-col sm:w-1/4 w-full mb-2">
              <vs-input
                v-validate="'decimal|max:8'"
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Total Freight"
                label-placeholder="Total Freight"
                name="tripFreightCharges"
                v-model="frm.tripFreightCharges"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('tripFreightCharges')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("tripFreightCharges") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('tripFreightCharges')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-2">
              <vs-input
                v-validate="'decimal|max:8'"
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Advance Paid"
                label-placeholder="Advance Paid"
                name="tripAdvancePaid"
                v-model="frm.tripAdvancePaid"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('tripAdvancePaid')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("tripAdvancePaid") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('tripAdvancePaid')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-2">
              <vs-input
                v-validate="'decimal|max:8'"
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Other Charges"
                label-placeholder="Other Charges"
                name="tripOtherCharges"
                v-model="frm.tripOtherCharges"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('tripOtherCharges')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("tripOtherCharges") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('tripOtherCharges')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-2">
              <vs-input
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Payable at"
                label-placeholder="Payable at"
                name="tripPayableBy"
                v-model="frm.tripPayableBy"
              />
              <span
                class="
                  text-danger text-sm
                  digitelex-form-error-message-container
                "
                v-if="errors.has('tripPayableBy')"
              >
                <span class="digitelex-form-error-message">
                  {{ errors.first("tripPayableBy") }}
                </span>
                <vx-tooltip
                  position="bottom"
                  :text="errors.first('tripPayableBy')"
                >
                  <vs-button
                    size="small"
                    radius
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-info"
                  ></vs-button>
                </vx-tooltip>
              </span>
            </div>
          </div>
        </vx-card>
        <div class="flex flex-wrap justify-end mt-2">
          <vs-button
            :disabled="!validateForm"
            v-if="
              !onlyAddConsignments ||
              frm.tripFlag != 3 ||
              sessionRoleId == 1 ||
              sessionRoleId == 2
            "
            @click="saveMemo"
            class="ml-auto"
            >Save Changes</vs-button
          >
          <!-- <vs-button class="ml-4" type="border" color="warning"
            >Cancel</vs-button
          > -->
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import activeLrList from "./activeLrsList.vue";

const dict = {
  custom: {
    clientName: {
      required: "Please enter your first name",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};

Validator.localize("en", dict);

export default {
  props: {
    frmData: {},
    onlyAddConsignments: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "v-select": vSelect,
    activeLrList: activeLrList,
  },
  methods: {
    getVehicles() {
      this.$http.get("portage/vehicles").then((response) => {
        this.vehiclesList = response.data.data;
        console.log(this.vehiclesList);
        // this.getBranchTypes();
      });
    },
    getBranchTypes() {
      this.$http.get("common/branchTypeEnum").then((response) => {
        this.branchTypeEnum = response.data.data;
        // this.$vs.loading.close("#add-edit-branch-container > .con-vs-loading");
      });
    },
    getBranches() {
      this.$http.get("common/branches").then((response) => {
        this.branches = response.data.data;
        this.toBranches = this.branches.filter((branch) => {
          return branch.branchId != this.frm.fromBranchId;
        });
        // this.$vs.loading.close("#add-edit-branch-container > .con-vs-loading");
      });
    },
    selectedConsignments(e) {
      this.showAddConsignments = false;

      if (this.frm.tripId != 0 && this.frm.tripId != "") {
        this.$http
          .post("portage/addLrToTrip", {
            consignmentsList: e,
            tripId: this.frm.tripId,
            tripUniq: this.frm.tripUniq,
          })
          .then((_response) => {
            console.log(e);
            this.frm.consignmentsList.push(...e);
            console.log(this.frm.consignmentsList);

            alert("Consignments Added Succesfully!");
            // this.$emit("submitResponse", response);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.frm.consignmentsList = e;
      }
      console.log(this.frm);
    },
    fromBranchSelected() {
      // alert(this.frm.fromBranchId);
      this.toBranches = this.branches.filter((branch) => {
        return branch.branchId != this.frm.fromBranchId;
      });
    },
    createNewVehicle(e) {
      console.log(e);
      console.log(
        this.vehiclesList.findIndex(
          (vehicle) =>
            vehicle.vehicleNo.toLowerCase() == e.vehicleNo.toLowerCase()
        )
      );
    },
    removeConsignment(e, index) {
      console.log(e);
      if (this.frm.tripId == 0) {
        this.frm.consignmentsList.splice(index, 1);
      } else if (this.frm.tripId != 0) {
        console.log("call Service call");
        this.$http
          .post("portage/removeLr", {
            consignmentId: e.consignmentId,
            tripId: this.frm.tripId,
          })
          .then((_response) => {
            this.frm.consignmentsList.splice(index, 1);
            // this.$emit("submitResponse", response);
          })
          .catch((error) => {
            console.log(error);
          });
        // this.frm.consignmentsList.splice(index,1)
      }
    },
    selectedOption(e) {
      this.frm.pVehicleId = e.vehicleId;
      this.frm.vehicleOwnerName = e.vehicleOwnerName;
      this.frm.vehicleNo = e.vehicleNo;
      this.frm.vehicleOwnerMobileNo = e.vehicleOwnerMobileNo;
      this.frm.vehicleOwnerGstNo = e.vehicleOwnerGst;
      this.frm.VehicleChassisNo = e.vehicleChassisNo;
      this.frm.vehicleEmptyWeight = e.vehicleEmptyWeight;
      this.frm.vehicleHasAllIndiaPermit = e.vehicleHasAllIndiaPermit;
      this.frm.vehicleAuthorityType = e.vehicleAuthorityType;
    },
    // handleVehicleNo: (map, vm) => ({
    //   ...map,
    //   50: (e) => {
    //     e.preventDefault();
    //     console.log(map);
    //     console.log(vm);
    //     console.log(e);
    //     if (vm.search.length > 0) {
    //       vm.search = String(vm.search).toUpperCase();
    //     }
    //   },
    // }),
    saveMemo() {
      if (this.frm.tripId) {
        //Update
        // alert("Updated");
        this.$http
          .put("portage/memo", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            console.log(error);
            alert(error.response.data.message);
          });
      } else {
        this.frm.isActive = true;
        this.frm.tripId = 0;
        this.$http
          .post("portage/memo", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            console.log(error);
            alert(error.response.data.message);
          });
      }
    },
  },
  data() {
    return {
      showAddConsignments: false,
      vehiclesList: [],
      branchTypeEnum: [],
      branches: [],
      toBranches: [],
      vehicleDropDown: null,
      modalTitle: "Add Consignments",
      localData: JSON.parse(localStorage.getItem("sstUnData")),
      sessionRoleId: JSON.parse(localStorage.getItem("sstUnData")).roles[0]
        .roleId,
      frm: {
        isActive: true,
        tripId: null,
        tripFlag: null,
        pVehicleId: null,
        vehicleNo: null,
        fromBranchId: JSON.parse(localStorage.getItem("sstUnData")).branchId,
        toBranchId: null,
        vehicleOwnerName: null,
        vehicleOwnerMobileNo: null,
        vehicleOwnerGstNo: null,
        vehicleEmptyWeight: 100,
        VehicleChassisNo: null,
        vehicleHasAllIndiaPermit: false,
        vehicleAuthorityType: false,
        tripDriveName: "",
        tripDriverMobileNo: null,
        tripDriverdlr: null,
        tripBookedDate: null,
        tripEngagedThrough: null,
        tripRanger: null,
        tripFreightCharges: 0,
        tripAdvancePaid: 0,
        tripOtherCharges: 0,
        tripPayableBy: null,
        consignmentsList: [],
      },
    };
  },
  watch: {
    frmData: {
      handler(after) {
        console.log(after);
        this.frm = after;
        if (this.frm.tripId == null || this.frm.tripId == "") {
          this.frm.tripId = 0;
        }
        console.log(this.frm);
        // alert(this.frm.consignmentLrNo);
        console.log(this.frm.consignmentsList);

        this.vehicleDropDown = this.frm.pVehicleId;
      },
      immediate: true,
    },
  },

  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  beforeMount() {
    this.getVehicles();
    this.getBranches();
  },
  mounted() {
    console.log("onlyAddConsignments", this.onlyAddConsignments);

    // this.frm.fromBranchId = JSON.parse(
    //   localStorage.getItem("sstUnData")
    // ).branchId;
  },
};
</script>
<style scoped>
/* .custom-number-input .vs-input-number--input {
  width: 100%  !important;
} */
.digitelex-higherpopup {
  z-index: 9999999999 !important;
}
</style>

<style lang="scss">
.digitelex-higherpopup {
  .vs-popup {
    width: 90%;
  }
}
</style>